"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barredLUnicodeChart = {
    l: "ł",
    L: "Ł"
};
exports.barredLUnicode = function (name) { return exports.barredLUnicodeChart[name]; };
//# sourceMappingURL=barred-letter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/unicode/commands/0args/barred-letter.js
// module id = 102
// module chunks = 0 1 2 3